import { createSlice } from "@reduxjs/toolkit";
import { createMaterialAPI } from "../../services/createMaterial";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
  statusCode: undefined,
};

const createMaterialSlice = createSlice({
  name: "createMaterial",
  initialState: data,
  reducers: {
    createMaterialInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
      state.statusCode = undefined;
    },
    createMaterialInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message =
        action?.payload?.message || "Material created successfully";
      state.error = "";
      state.statusCode = undefined;
    },
    createMaterialInfoFailure(state, action) {
      const payload =
        action.payload && typeof action.payload === "object"
          ? action.payload
          : { message: action.payload };
      state.isLoading = false;
      state.message = "";
      state.error = payload.message ?? "";
      state.statusCode = payload.statusCode;
      state.data = null;
    },
    createMaterialInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
      state.statusCode = undefined;
    },
  },
});

export const createMaterialHandler =
  (payload, options = {}) =>
  async (dispatch) => {
    const requestOptions = { skipForbiddenRedirect: true, ...options };

    try {
      dispatch(createMaterialAction.createMaterialInfo());
      const response = await createMaterialAPI(payload, requestOptions);
      dispatch(createMaterialAction.createMaterialInfoSuccess(response));
    } catch (e) {
      const failurePayload =
        e && typeof e === "object" && "message" in e
          ? e
          : { message: e || "Something went wrong." };
      dispatch(createMaterialAction.createMaterialInfoFailure(failurePayload));
    }
  };

export default createMaterialSlice.reducer;
export const createMaterialAction = createMaterialSlice.actions;
